/**
 * Run a function if it is safe to do so when taking SSR into account.
 * @param func The function to run if it is safe to do so.
 * @param dependencies Any extra dependencies to check.
 */
 export function ssrSafe<T>(
  func: () => T,
  dependencies: any[] = [
    (typeof process === "object" && (process as any).browser) ||
      typeof window === "object",
  ]
) {
  // ensures browser specific functions are run only if browser is available whether in ssr or client
  if (dependencies.every(Boolean)) {
    return func();
  }

  return undefined;
}

export function makeSsrSafe<T extends CallableFunction>(
  func: T,
  dependencies?: any[]
): T {
  return function (this: ThisParameterType<T>, ...args: any[]) {
    return ssrSafe(() => {
      return (func as any).call(this, ...args);
    }, dependencies);
  } as any as T;
}

export const isIos = makeSsrSafe(() => {
  return Boolean(
    navigator.userAgent && /ipad|iphone|ipod/i.test(navigator.userAgent)
  );
});

export const isAndroid = makeSsrSafe(() => {
  return Boolean(navigator.userAgent && /android/i.test(navigator.userAgent));
});

export const isIE = makeSsrSafe(() => {
  return Boolean(/MSIE|Trident/i.test(window.navigator.userAgent));
});
